import axios from 'axios'
import router from '@/router/routers'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken , removeToken } from '@/utils/auth'
import Config from '@/config'
import { done } from 'nprogress'



// 请求工具类
// 创建axios实例
const service = axios.create({
    // baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_API : '/', // api 的 base_url
    timeout: Config.timeout // 请求超时时间
})



// //拦截器设置token
// axios.interceptors.request.use(
//   config => {
//     if(localStorage.token) {
//       if (config.method == 'get' || config.method == 'GET') {
//         if (config.url.indexOf("?") != -1) {
//           config.url += "&r=" + Math.random();
//         } else {
//           config.url += "?r=" + Math.random();
//         }
//       }
//       config.headers.Authorization = localStorage.token;
//     }
//     return config
//   },error => {
//     return Promise.reject(error)
//   }
// )
//
// axios.interceptors.response.use(
//   response => {
//     if(response.data.no == -6) {
//       //在其他终端登录，提示用户
//       localStorage.token = '';
//       alert('您的账号在别的地方登陆了')
//       router.push('/user')
//     }
//     return response
//   },error => {
//     if(error.response) {
//       //后台验证token失效返回401，跳转重新登录
//       if(error.response.status == 401) {
//         if(error.response.data.no == -6) {
//           localStorage.token = '';
//           alert('您的账号在别的地方登陆了')
//           router.push('/user')
//         }else {
//           localStorage.token = '';
//           alert('当前登录已过期，请重新登录');
//           router.push('/user')
//         }
//
//       }
//     }
//   }
// )

// request拦截器
service.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        // config.headers['Content-Type'] = 'application/json';
        //连本地的时候放开；
        // config.headers['user-id'] = '231';
        // config.headers['user-eid'] = '1';
        // config.headers['Referer'] = 'shangshaban.com';
        return config
    },
    error => {
        // Do something with request error
        // console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const code = response.status;
        if (code < 200 || code > 300) {
            Notification.error({
                title: response.message
            })
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        let code = 0;
        try {
            code = error.response.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                Notification.error({
                    title: '网络请求超时',
                    duration: 2500
                })
                return Promise.reject(error)
            }
            if (error.toString().indexOf('Error: Network Error') !== -1) {
                Notification.error({
                    title: '网络请求错误',
                    duration: 2500
                })
                return Promise.reject(error)
            }
        }
        if (code === 401) {  // && 
            removeToken();
          setTimeout(()=>{
              if (window.isShow) {
                window.isShow = false;
                window.timer = window.setInterval(func,1500);
                function func(){
                    window.isShow = true;
                };
                MessageBox.confirm(
                    '登录状态已过期，您可以继续留在该页面，或者重新登录',
                    '系统提示', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).then(() => {
                    window.isShow = false;
                    localStorage.clear();
                    store.dispatch('LogOut').then(() => {
                        // location.reload() // 为了重新实例化vue-router对象 避免bug
                        // location.reload(true) // 为了重新实例化vue-router对象 避免bug
                    })
                }).catch(() => {
                    window.isShow = false;
                })
            }
          })
        } else if (code === 403) {
            Notification.error({
                title: '网络请求错误,状态码403',
                duration: 2500
            })
        } else if (code === 404) {
            Notification.error({
                title: '网络请求错误,状态码404',
                duration: 2500
            })
        } else {
            const errorMsg = error.response.data.message
            if (errorMsg !== undefined) {
                Notification.error({
                    title: '数据请求异常',
                    duration: 3000
                })
            }
        }
        return Promise.reject(error)
    }
)
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js